import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { motion } from 'framer-motion';
interface LayoutProps {
  children: React.ReactNode;
}
export function Layout({
  children
}: LayoutProps) {
  return <div className="flex flex-col min-h-screen" data-id="element-147">
      <Navbar data-id="element-148" />
      <motion.main initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.5
    }} className="flex-grow" data-id="element-149">
        {children}
      </motion.main>
      <Footer data-id="element-150" />
    </div>;
}